import { IFundingService } from "../Interfaces";
import { INotificationService } from "../../common/services/INotificationService";
import { VarianceStatementSummary, SupplementsVariance } from "../Models";
import { Constants } from "../../common/Constants";

class VarianceStatementSummaryComponent implements ng.IComponentOptions {
    public bindings: any;
    public templateUrl: string = 'app/funding/partials/varianceStatementSummary.html';

    constructor() {
        this.bindings = {
            monthAndYear: '='
        };
    }

    public controller: any = class VarianceStatementComponentController {
        static $inject = ["funding.service", "notification.service", "$filter", "utilities.service"];

        public monthAndYear: string;
        public yearAndMonth: number;
        public varianceStatementSummary: VarianceStatementSummary;
        public july2024 = Constants.JULY_2024;

        constructor(private readonly fundingService: IFundingService,
            private readonly notificationService: INotificationService,
            private readonly filter: any,
            private readonly utilitiesService: any
        ) {
            this.yearAndMonth = +this.utilitiesService.convertMonthYearToYearMonth(this.monthAndYear);
            this.getSummary();
        }

        public getVariance = (input: number): string => {
            if (input == 0) return '0.00';
            return input < 0 ? `(${this.filter('currency')(Math.abs(input), '', 2)})` : this.filter('currency')(input, '', 2);
        }

        private getSummary = () => {
            this.fundingService.getVarianceSummary(this.monthAndYear).then((result) => {
                this.varianceStatementSummary = result;
            },
                () => {
                    this.notificationService.error("Unexpected error occurred while fetching the variance summary.");
                }
            );
        }
    }
}
export = VarianceStatementSummaryComponent;